import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-exception-dialog',
    templateUrl: './exception-dialog.component.html',
    styleUrls: ['./exception-dialog.component.scss'],
    standalone: false
})
export class ExceptionDialogComponent implements OnInit {

  navigationSubs: Subscription;

  constructor(@Inject(MAT_DIALOG_DATA) public data, private router: Router, public dialogRef: MatDialogRef<ExceptionDialogComponent>) { 
    this.navigationSubs = this.router.events.subscribe(e => {
      if(e instanceof NavigationEnd){
        this.dialogRef.close();
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
  }
}
